import React from 'react';
import PopupDeleteTransfer from '../../TransfersByAgent/components/PopupDeleteTransfer';
import PopupEditTransfer from '../../TransfersByAgent/components/PopupEditTransfer';
import {PopupEditTransferContextProvider} from '../../TransfersByAgent/contexts/PopupEditTransferContext';
import {PopupViewTransferContextProvider} from '../../TransfersByAgent/contexts/PopupViewTransferContext';
import {TransferCalculationContextProvider} from '../../TransfersByAgent/contexts/TransferCalculationContext';
import PopupViewTransfer from '../../TransfersByAgent/components/PopupViewTransfer';

export function TransfersActionsColumnFormatter(cellContent, fullName, canDelete) {

  return (
    <div className={'d-flex justify-content-around align-items-center'}>
      <TransferCalculationContextProvider>
        <PopupViewTransferContextProvider cellContent={cellContent}>
          <PopupViewTransfer fullName={fullName} transferID={cellContent?._id ? cellContent._id : ''}/>
        </PopupViewTransferContextProvider>
        <PopupEditTransferContextProvider cellContent={cellContent}>
          <PopupEditTransfer fullName={fullName}/>
        </PopupEditTransferContextProvider>
        <PopupDeleteTransfer data={cellContent} canDelete={canDelete}/>
      </TransferCalculationContextProvider>
    </div>
  );
}
